import { render } from "./NewsCreate.vue?vue&type=template&id=1caed1e2&scoped=true"
import script from "./NewsCreate.vue?vue&type=script&lang=js"
export * from "./NewsCreate.vue?vue&type=script&lang=js"

import "./NewsCreate.vue?vue&type=style&index=0&id=1caed1e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1caed1e2"]])

export default __exports__